<template>
  <b-card class="mb-4" no-header>
    <b-row>
      <b-col cols="12">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <b-button-group class="add-button-group">
            <b-btn variant="primary" to="/sekolah/create"
              ><font-awesome-icon icon="plus" /> Tambah Data</b-btn
            >
          </b-button-group>
        </div>
      </b-col>
      <b-col cols="12" class="mb-3">
        <b-form @submit.prevent="doFilter">
          <b-row class="filter-row">
            <b-col cols="6" md="4">
              <form-group-input
                ref="filter-school_name"
                type="text"
                v-model="filter.school_name"
                placeholder=""
                :need-label="true"
                label="Nama Sekolah"
                id="filter-school_name"
              />
            </b-col>
            <b-col cols="6" md="4">
              <form-group-input
                ref="filter-npsn"
                type="text"
                v-model="filter.npsn"
                placeholder=""
                :need-label="true"
                label="NPSN"
                id="filter-npsn"
              />
            </b-col>
            <b-col cols="6" md="4">
              <form-group-input
                ref="filter-district"
                type="enum"
                :options="list.district"
                v-model="filter.district_id"
                placeholder=""
                :need-label="true"
                label="Kecamatan"
                id="filter-district"
              />
            </b-col>
            <b-col cols="6" md="4">
              <form-group-input
                ref="filter-village_id"
                type="enum"
                :options="list.village"
                v-model="filter.village_id"
                placeholder=""
                :need-label="true"
                label="Desa / Kelurahan"
                id="filter-village_id"
              />
            </b-col>
            <b-col cols="6" md="4">
              <label class="form-label">&nbsp;</label><br />
              <b-btn type="submit" class="btn-in-form" variant="primary">
                <font-awesome-icon icon="search" /><span>Cari</span>
              </b-btn>
              <b-btn
                type="button"
                @click.prevent="clearForm"
                variant="secondary"
                class="btn-in-form ml-2"
              >
                <font-awesome-icon icon="broom" /><span>Clear</span>
              </b-btn>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
    <paginated-table
      ref="dataTable"
      :delete-reason="false"
      :can-delete="true"
      :can-edit="true"
      :data-url="apiUrl.school"
      :data-columns="columns"
      :dataParams="dataParams"
      :defaultDataParams="this.filter"
    >
      <template slot="content_district_id" slot-scope="defaultSlotScope">
        <span style="text-transform: capitalize">{{
          defaultSlotScope.colData.district.name
        }}</span>
      </template>
    </paginated-table>
  </b-card>
</template>

<script>
import { objectToOptions, classicObjectToOptions } from "@/_helpers";
import paginatedTable from "@/components/PaginatedTable.vue";
import formGroupInput from "@/components/FormGroupInput.vue";
import School from "@/models/School.js";
import District from "@/models/District.js";
import City from "@/models/City.js";
import Village from "@/models/Village.js";

const schoolModel = new School();
const districtModel = new District();
const cityModel = new City();
const villageModel = new Village();

export default {
  components: {
    formGroupInput,
    paginatedTable,
  },
  data() {
    return {
      isLoading: false,
      apiUrl: {
        school: schoolModel.endpoint,
      },
      columns: [
        {
          prop: "school_name",
          label: "Nama Sekolah",
          sortable: true,
          resizable: true,
          minWidth: 200,
        },
        {
          prop: "district_id",
          label: "Kecamatan",
          sortable: true,
          resizable: true,
          minWidth: 200,
        },
        {
          prop: "npsn",
          label: "NPSN",
          sortable: true,
          resizable: true,
          minWidth: 200,
        },
        {
          prop: "kepsek",
          label: "Kepala Sekolah",
          sortable: true,
          resizable: true,
          minWidth: 200,
        },
        // {
        //   prop: 'is_active',
        //   label: 'Status',
        //   isToggle: true,
        //   resizable: true,
        //   sortable: true,
        //   minWidth: 80
        // }
      ],
      list: {
        city: [],
        district: [],
        village: [],
      },
      filter: {
        school_name: "",
        npsn: "",
        village_id: "",
        district_id: "",
        city_id: this.$route.query.city_id ?? null,
        district_id:
          typeof this.$route.query.district_id !== "undefined"
            ? this.$route.query.district_id
            : null,
        village_id:
          typeof this.$route.query.village_id !== "undefined"
            ? this.$route.query.village_id
            : null,
      },
      dataParams: [
        "city_id",
        "district_id",
        "village_id",
        "school_name",
        "npsn",
        "kepsek",
        "with_stats",
      ],
    };
  },
  beforeMount() {
    this.$router
      .push({
        query: {
          ...this.$route.query,
          ...{ city_id: "950b9f62-d1c6-476b-a12d-9233fe332a75", with_stats: "1" },
        },
      })
      .catch((err) => {});
  },
  async mounted() {
    if (typeof this.$route.query.city_id !== "undefined") {
      this.list.district = objectToOptions(
        await this.getDistricts(this.$route.query.city_id)
      );
    }
    if (typeof this.$route.query.district_id !== "undefined") {
      this.list.village = objectToOptions(
        await this.getVillages(this.$route.query.district_id)
      );
    }

    this.getCities();
  },
  watch: {
    "filter.district_id": async function (val, oldVal) {
      if (val) {
        this.list.village = objectToOptions(
          await this.getVillages(val)
        );
        this.filter.village_id = null;
      } else {
        this.filter.district_id = null;
      }
    },
  },
  methods: {
    getCities() {
      cityModel
        .list({
          name: "labuhan",
          province_id: "950b9d3a-c996-4207-97e7-5a2858981979",
          limit: 10000,
        })
        .then((resp) => {
          let data = [];
          // data[null] = 'Tidak Ada'
          resp.data.forEach((d) => {
            data[d.id] = d.name;
          });
          this.list.city = objectToOptions(data);
        });
    },
    async getDistricts(cityId) {
      return new Promise((resolve) => {
        districtModel
          .list({
            city_id: cityId,
          })
          .then((resp) => {
            let data = [];
            // data[null] = 'Tidak Ada'
            resp.data.forEach((d) => {
              data[d.id] = d.name;
            });
            resolve(data);
            // this.userModel.district_id.options = data
          });
      });
    },
    async getVillages(districtId) {
      return new Promise((resolve) => {
        villageModel
          .list({
            district_id: districtId,
          })
          .then((resp) => {
            let data = [];
            // data[null] = 'Tidak Ada'
            resp.data.forEach((d) => {
              data[d.id] = d.name;
            });
            resolve(data);
            // this.userModel.village_id.options = data
          });
      });
    },
    clearForm() {
      this.$nextTick(() => {
        this.filter = {
          school_name: "",
          npsn: "",
          village_id: "",
          district: "",
        };
        this.list = {
          village: [],
        };
        setTimeout(() => {
          this.doFilter();
        }, 100);
      });
    },
    doFilter() {
      this.$refs.dataTable.doFilter(this.filter);
    },
    // doExport() {
    //   if (this.isLoading) {
    //     return false;
    //   }
    //   this.isLoading = true;
    //   const filterArray = [];
    //   Object.keys(this.filter).forEach((key) => {
    //     if (this.filter[key]) {
    //       filterArray.push(key + "=" + this.filter[key]);
    //     }
    //   });
    //   filterArray.push("csv=1");

    //   this.$http
    //     .get(userModel.getEndpoint() + "?" + filterArray.join("&"))
    //     .then((response) => {
    //       const a = document.createElement("a");

    //       const blob = new Blob([response.data], { type: "octet/stream" });
    //       a.href = window.URL.createObjectURL(blob);

    //       a.download = "data_admin.csv";
    //       a.click();
    //       this.isLoading = false;
    //     })
    //     .catch((error) => {
    //       this.$store.dispatch("notification/error", error);
    //       this.isLoading = false;
    //     });
    // },
  },
};
</script>